import { BaseApiResponse } from './base-api-response';

/**
 * Api response of T
 */
export class ApiResponse<T> extends BaseApiResponse {
	data?: T;
}
